import { AnomalyIncident } from './AnomalyIncident';

export type AnomalyMetricKey = 'brand_score' | 'average_position' | 'visibility';

export type AnomalyMetricSemantics = {
  increaseIsPositive: boolean;
};

export type AnomalyMetricIncidents = {
  semantics: AnomalyMetricSemantics;
  data: AnomalyIncident[];
};

export type AnomalyIncidentsResponse = Record<AnomalyMetricKey, AnomalyMetricIncidents>;

export const getEmptyAnomalyIncidentsResponse = (): AnomalyIncidentsResponse => ({
  brand_score: { semantics: { increaseIsPositive: true }, data: [] },
  average_position: { semantics: { increaseIsPositive: true }, data: [] },
  visibility: { semantics: { increaseIsPositive: true }, data: [] },
});
